import { Repo } from '@/@types/@repo'

type PreviewMode = 'template' | 'logo'

export type RepoPreview = {
  url: string
  mode: PreviewMode
}

const isGifUrl = (url: string) => /\.gif(?:$|[?#])/i.test(url)

export default function resolveRepoPreview(project: Repo): RepoPreview | null {
  const templateUrl = project.template?.url || project.template_url || ''
  const logoUrl = project.logo_url || project.logo_symbol_url || ''

  if (templateUrl) {
    if (isGifUrl(templateUrl)) {
      if (logoUrl) return { url: logoUrl, mode: 'logo' }
      return { url: templateUrl, mode: 'template' }
    }

    return { url: templateUrl, mode: 'template' }
  }

  if (logoUrl) {
    return { url: logoUrl, mode: 'logo' }
  }

  return null
}
